/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export class AppVersion {
  private static regex = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})-?(\w+)?\.?(\d{1,3})?$/;

  major: number;
  minor: number;
  patch: number;

  build: string;
  build_number: number;

  static parseVersion(v: string): any{
    let ver: RegExpExecArray = AppVersion.regex.exec(v);
    if(ver){
      let appVersion = new AppVersion();

      appVersion.major = Number(ver[1]);
      appVersion.minor = Number(ver[2]);
      appVersion.patch = Number(ver[3]);

      if(ver[4])
        appVersion.build = ver[4];

      if(ver[5])
        appVersion.build_number = Number(ver[5]);

      return appVersion;
    }else return null;
  }
}
